import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { PropTypes } from 'prop-types'
import { Modal } from 'react-bootstrap';
import { Form } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { Center, ImageSection, Black, Red, ModalHeading } from '../../GeneralStyle'

import ReactGA from "react-ga";

import moment from 'moment'

import headerImage from '../../../images/modal/tl_header_login.jpg';
import { LogeButtonSlim } from './ActiveResidenceBookingsStyle';

@inject('residenceBookingStore')

@observer
class ResidenceCancelModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: this.props.showModal,
      cancelSuccess: false,
      isError: false,
      errorMessage: ""
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  openModal(data) {
    this.setState({ showModal: true });
  }

  closeModal(data) {
    this.props.residenceBookingStore.rerender()
    this.setState({ showModal: false });
  }

  onSubmit() {
    this.props.residenceBookingStore.cancelBooking(
      this.props.bookingId
    ).then(res => {
      ReactGA.event({
        category: 'Residence',
        action: 'Click Button',
        label: 'Cancel Residence Booking'
      });
      this.setState({
        cancelSuccess: true
      })
    }).catch(err => {
      this.setState({
        isError: true,
        errorMessage: err.message.message
      })
    })
  }

  render() {

    const sureCancelButton = (
      <div>
        <Center marginTop={30}>
          <Black>Wollen sie Ihre Residence Buchung in {this.props.residenceName}, von {moment(this.props.arrival).locale("de").format('Do MMMM YYYY')} bis  {moment(this.props.depature).locale("de").format('Do MMMM YYYY')}  wirklich stornieren?</Black>
        </Center>
        <Form
          onSubmit={this.onSubmit}
          layout={'vertical'}
          validateOnSubmit={false}
          validatePristine={false}
          formNoValidate
          noValidate
        >
          <Center marginTop={30} marginBottom={30}>
            <LogeButtonSlim
              hoverFontColor={"white"}>
              Bestätigen
              </LogeButtonSlim>
          </Center>
        </Form>
      </div>
    )

    const cancelSuccess = (
      <div>
        <Center marginTop={30}>
          <Black>Ihre Stornierung war erfolgreich!</Black>
        </Center>
          <Center marginTop={30} marginBottom={30}>
            <LogeButtonSlim
              onClick={() => this.closeModal()}
              hoverFontColor={"white"}>
              Schließen
              </LogeButtonSlim>
          </Center>
      </div>
    )
    const errorButton = (
      <div>
        <Center marginTop={30}>
          <Red>{this.state.errorMessage}</Red>
        </Center>
        <Form
          onSubmit={this.closeModal}
          layout={'vertical'}
          validateOnSubmit={false}
          validatePristine={false}
          formNoValidate
          noValidate
        >
          <Center marginTop={30} marginBottom={30}>
            <LogeButtonSlim
              onClick={() => this.closeModal}
              hoverFontColor={"white"}>
              Abbrechen
              </LogeButtonSlim>
          </Center>
        </Form>
      </div>
    )
    return (
      <Modal show={this.state.showModal} onHide={this.closeModal}>
        <ImageSection background={headerImage}>
          <Modal.Header closeButton>
            <Modal.Title>
              <div>
                <ModalHeading>
                  Buchung stornieren
                </ModalHeading>
              </div>
            </Modal.Title>
          </Modal.Header>
        </ImageSection>
        <Modal.Body>
          {this.state.cancelSuccess
            ? cancelSuccess
            : this.state.isError ? errorButton : sureCancelButton
          }

        </Modal.Body>
      </Modal>
    );
  }
}

ResidenceCancelModal.propTypes = {
  residenceBookingStore: MobxPropTypes.observableObject,
  bookingId: PropTypes.string,
  residenceName: PropTypes.string,
  arrival: PropTypes.string,
  depature: PropTypes.string,
};

export default withRouter(ResidenceCancelModal);



// WEBPACK FOOTER //
// /src/components/internal/Residence/ResidenceCancelModal.js